
$(document).ready(function(){
  $('.home_add_to_cart_form').on('click', function(event) {
    event.preventDefault(); 
    var data_id = $(this).attr("data-product-id");
    var lng_id = $(this).attr("data-lng-id");
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: $("#add_to_cart_form_"+data_id).serialize(),
      dataType: 'json',
      success: function() {
        var origin   = window.location.origin;
        if(lng_id == 'pl'){
          window.location.href = origin +"/cart";
        }else{
          window.location.href = origin + "/" +lng_id+"/cart";
        }
        
      },
      error: function() {
        // Do something on error (e.g. show an error message)
      }
    });
  });
});